import { MapPin, Navigation } from "lucide-react";
import { COVERAGE } from "../data/mock";

export const CoverageSection = () => {
  return (
    <section id="coverage" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 bg-navy-50 border border-navy-100/80 rounded-full px-4 py-1.5 mb-6">
            <MapPin size={13} className="text-hevi-blue" />
            <span className="text-hevi-blue font-semibold text-[11px] uppercase tracking-[0.15em]">
              {COVERAGE.label}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold text-navy-900 leading-tight mb-5">
            NIAGARA-BASED. <span className="text-hevi-red">ONTARIO-WIDE.</span> CROSS-BORDER READY.
          </h2>
        </div>

        {/* Coverage Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3.5 lg:gap-4 mb-12">
          {COVERAGE.regions.map((region, i) => (
            <div
              key={i}
              className="group flex items-center gap-3 bg-[hsl(220,25%,97%)] rounded-xl p-5 border border-slate-200/40 hover:border-hevi-blue/20 hover:bg-navy-50/40 transition-all duration-300 cursor-default"
            >
              <Navigation size={14} className="text-hevi-blue shrink-0" />
              <span className="text-[13px] font-semibold text-navy-800">{region}</span>
            </div>
          ))}
        </div>

        {/* Cross Border Badge */}
        <div className="text-center">
          <div className="inline-flex items-center gap-3 sm:gap-4 rounded-2xl px-5 sm:px-8 py-4 sm:py-5 shadow-xl border border-white/10" style={{ background: 'linear-gradient(135deg, #070e24, #0c1839)' }}>
            <div className="flex items-center gap-1.5 text-xl sm:text-2xl">
              <span>🇨🇦</span>
              <span>🇺🇸</span>
            </div>
            <div className="text-left">
              <p className="text-white font-bold text-xs sm:text-sm">{COVERAGE.subtitle}</p>
              <p className="text-white/50 text-[10px] sm:text-xs mt-0.5">{COVERAGE.description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
